import * as React from 'react';
export const nhSvg = React.forwardRef(function nhSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#005CA9',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.626 4.5 16 6.823 11.374 4.5 16 13.296 20.626 4.5Z',
      fill: '#FBBA00',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm22.244 11.301-.07-.062 3.302-1.39V5.21l-5.735 2.447s-3.108 5.887-3.18 6.02a4.815 4.815 0 0 1 4.26 4.788 4.836 4.836 0 0 1-4.826 4.831 4.833 4.833 0 0 1-4.826-4.83 4.81 4.81 0 0 1 4.26-4.789c-.072-.133-3.175-6.02-3.175-6.02L6.53 5.209v4.64l3.298 1.39-.071.062A9.506 9.506 0 0 0 6.5 18.464c0 5.24 4.26 9.505 9.5 9.505s9.5-4.264 9.5-9.505a9.513 9.513 0 0 0-3.256-7.163Z',
      fill: '#FBBA00',
    }),
  );
});
nhSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var nh = {
  category: 'brand',
  colorable: false,
  name: 'nh',
  svg: nhSvg,
};
